import { useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { useDatasets } from '../hooks';
import { formatDate, formatDuration, formatRows, formatTime } from '../../../shared/format';

function sourceLabel(format: string): string {
  if (format === 'csv_v2') return 'CSV · v2';
  if (format === 'xlsx_v2') return 'XLSX · v2';
  if (format === 'xlsx_v1') return 'XLSX · v1';
  if (format === 'live') return '实时 · v2';
  return format;
}

export default function Datasets() {
  const datasets = useDatasets();
  const [query, setQuery] = useState('');

  const list = useMemo(() => {
    const all = datasets.data ?? [];
    const q = query.trim().toLowerCase();
    if (!q) return all;
    return all.filter((d) =>
      `${d.sessionId} ${d.sourceFilename} ${d.startedAt ?? ''} ${d.sourceFormat}`
        .toLowerCase()
        .includes(q),
    );
  }, [datasets.data, query]);

  return (
    <>
      <div className="page-head">
        <div>
          <div className="eyebrow">CCS · Sessions</div>
          <h1>会话</h1>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <span className="badge">{datasets.data?.length ?? 0} 个数据集</span>
          <input
            className="input"
            style={{ width: 260, height: 36 }}
            placeholder="搜索会话 ID 或日期"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
          />
        </div>
      </div>

      {datasets.isLoading ? (
        <div className="empty">加载中…</div>
      ) : list.length ? (
        <div className="dataset-list">
          {list.map((d) => {
            const empty = d.rowCount === 0;
            const live = d.status === 'live';
            const target =
              live && d.summary?.deviceId
                ? `/ccs/live/${d.summary.deviceId}`
                : `/ccs/datasets/${d.id}`;
            return (
              <Link
                key={d.id}
                to={target}
                className="dataset-row"
                style={empty ? { opacity: 0.72 } : undefined}
              >
                <div className="dataset-main">
                  <b>
                    {formatDate(d.startedAt)}
                    {d.startedAt ? ` · ${formatTime(d.startedAt)}` : ''}
                  </b>
                  <span className="mono">{d.sessionId}</span>
                </div>
                <div className="badge-row">
                  <span className="badge">{sourceLabel(d.sourceFormat)}</span>
                  {live ? <span className="badge ok">实时中</span> : null}
                  {empty && !live ? <span className="badge warn">空会话</span> : null}
                  {d.gapCount > 0 ? (
                    <span className="badge warn">丢帧 {d.gapCount}</span>
                  ) : null}
                </div>
                <div className="metric">
                  <b>{formatDuration(d.durationS)}</b>
                  <span>时长</span>
                </div>
                <div className="metric">
                  <b>{formatRows(d.rowCount)}</b>
                  <span>行</span>
                </div>
                <span className="badge accent">{live ? '进入实时 →' : '打开回放 →'}</span>
              </Link>
            );
          })}
        </div>
      ) : (
        <div className="empty">
          <b>{query ? '没有匹配的会话' : '还没有导入数据'}</b>
          {query ? '换个关键词试试。' : '把 CSV 或 xlsx 放到服务器后用 importer 导入。'}
        </div>
      )}
    </>
  );
}